import { useLang } from "@/lib/i18n";
import { Ornament } from "./Ornament";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative py-8 md:py-10 border-y border-white/10 overflow-hidden bg-[var(--gold)] text-[#0A0D14]" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {items.map((m, i) => (
              <span key={i} className="flex items-center font-display uppercase text-2xl md:text-4xl whitespace-nowrap px-6 md:px-10">
                {m}
                <Ornament className="w-10 md:w-14 ml-12 md:ml-20" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
